// @flow
import { BasePlugin } from "@uppy/core";

type uppyFileMetadata = {
    type: string,
};

export type uppyFile = {
    id: string, // 'uppyteamkongjpg1501851828779'
    name: string, // 'nature.jpg'
    extension: string, // '.jpg'
    type: string, // 'image/jpeg'
    data: Object, // the Blob object
    size: number | string, // 3947642 (returns 'N/A' if size cannot be determined)
    preview: string, // value that can be used to populate "src" attribute of an "img" tag,
    meta: uppyFileMetadata,
};

/* istanbul ignore next */
export default class UppyUpload extends BasePlugin {
    constructor(uppy: Object, opts: Object) {
        super(uppy, opts);
        this.uppy = uppy;
        this.type = "upload";
        this.id = opts.id || "Upload";

        // set default options
        const defaultOptions = {
            mode: this.uppy.opts.mode,
        };

        // merge default options with the ones set by user
        this.opts = Object.assign({}, defaultOptions, opts);
    }

    install() {
        this.uppy.log("[Upload] Installing UppyUpload Plugin");
        this.uppy.addPreProcessor(this.prepareUpload);
        this.uppy.on("upload-prepared", this.handleUploadPrepared);
    }

    uninstall() {
        this.uppy.log("[Upload] Removing UppyUpload Plugin");
        this.uppy.removePreProcessor(this.prepareUpload);
        this.uppy.off("upload-prepared", this.handleUploadPrepared);
    }

    handleUploadPrepared = (file: uppyFile) => {
        const meta = {
            ...file.meta,
            name: file.name,
            mode: this.opts.mode,
            lastModified: file.data?.lastModified
                ? new Date(file.data.lastModified).toISOString()
                : Date.now().toISOString(),
        };
        this.uppy.log(`[Upload] Preparing ${file.name}`);
        console.log(`[Upload] Preparing ${file.name}`, meta);
        this.uppy.setFileMeta(file.id, meta);
    };

    prepareUpload = () =>
        new Promise((resolve) => {
            this.uppy.log("[Upload] Preprocessing files for upload");
            // reset state to allow new uploads
            this.uppy.setState({ allowNewUpload: true });
            this.uppy.getFiles()?.forEach((file) => {
                // apply any custom logic
                this.uppy.emit("upload-prepared", file);
            });
            resolve();
        });
}
